import Request from './request';
export default class Journal {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new Journal());
	}

	constructor() {
		
	}
	
	journalId() {
		return this.journal ? this.journal.id : null;
	}
	
	journalCode() {
		return this.variables ? this.variables.docJournalCode : null;
	}

	journalLinks() {
		return this.variables ? this.variables.docNavigationLinks : [];
	}
	
	journalTitle() {
		return this.variables ? this.variables.appTitle + ": Documentation" : "HyperDoc";
	}
	
	notificationsDashboardUrl() {
		return this.variables ? this.variables.notificationsDashboardUrl : null;
	}
	
	matchJournal() {
		var domain = location.hostname;
		return Request.instance().doRequest('get', '/domain/variables', null, { host: domain })
			.then(domResult => {
				this.variables = domResult.data;
				return Request.instance().get('/public/journal/match', { code: this.journalCode() })
					.then(result => {
						this.journal = result.data;
					});
			});
	}
	
}